import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SFArrowUpIcon, SFArrowDownIcon } from "../../../icons";
import SFCheckbox from "../../../checkbox";
import SFIconButton from "../../../button/iconButton";
import SFAuthorized from "../../../authorized";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const ActionIconsStyled = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  height: "100%",
}));

const MasterDetailsIcon = ({ rowExpanded, toggleMasterDetails, ...props }) => (
  <SFAuthorized permissions={props.context.permissions?.viewDetails}>
    <SFIconButton onClick={toggleMasterDetails}>
      {rowExpanded ? (
        <SFArrowUpIcon color="primary" />
      ) : (
        <SFArrowDownIcon color="primary" />
      )}
    </SFIconButton>
  </SFAuthorized>
);

const SFActionsRenderer = (props) => {
  const [rowExpanded, setRowExpanded] = useState(props.node.expanded);
  const [rowSelected, setRowSelected] = useState(props.node.isSelected());
  const toggleMasterDetails = () => {
    setRowExpanded(rowExpanded ? false : true);
    if (!props.context.allowMultipleDetailRows) {
      props.api.forEachNode((node) => node.setExpanded(false));
    }
    props.node.setExpanded(rowExpanded ? false : true);
  };

  const onRowSelected = () => {
    if (props.node.isSelected()) {
      setRowSelected(true);
    } else {
      setRowSelected(false);
    }
  };

  useEffect(() => {
    props.node.addEventListener("rowSelected", onRowSelected);

    onRowSelected();

    return function () {
      props.node.removeEventListener("rowSelected", onRowSelected);
    };
  }, []);

  if (
    props.benchmarkDataFilterEnabled &&
    props.exposedData?.length > 0 &&
    !props.exposedData.find((x) => x.code === props.data.code)
  ) {
    return null;
  }

  if (props.context.isRowMaster && !props.context.isRowMaster(props.data)) {
    return null;
  }

  return (
    <ActionIconsStyled>
      {props.context.masterDetail && (
        <MasterDetailsIcon
          {...props}
          rowExpanded={rowExpanded}
          toggleMasterDetails={toggleMasterDetails}
        />
      )}
      {/* Read selection and onCheck from colDef or context (v33 migration) */}
      {(props.colDef.selection ?? props.colDef.context?.selection) && (
        <SFCheckbox
          checked={rowSelected}
          onChange={() => {
            props.node.setSelected(!props.node.isSelected());
            if (props.context.persistState) {
              props.context.onRowSelected(
                props.node.data,
                props.node.isSelected()
              );
            }
            const onCheck = props.colDef.onCheck ?? props.colDef.context?.onCheck;
            if (onCheck) {
              onCheck(props.node.data, props.node.isSelected());
            }
          }}
        />
      )}
    </ActionIconsStyled>
  );
};

SFActionsRenderer.propTypes = {
  context: PropTypes.any,
  data: PropTypes.any,
  node: PropTypes.any,
};

export default SFActionsRenderer;
